import packageJson from '../../package.json';

const LOCAL_ADDRESS = 'http://localhost:5173';

const CENTRAL_ROUTER = process.env.REACT_APP_ROUTER_API_URL || undefined;
const CENTRAL_ROUTER_API_KEY = process.env.REACT_APP_ROUTER_API_KEY || undefined;

type ApiEnv = {
    address: string;
    key: string;
}

const getApiEnv = (apiEnv: string, keyEnv: string, serviceName: string): ApiEnv => {
    if (process.env[apiEnv]) {
        return {
            address: process.env[apiEnv]!.replace(/\/+$/, ''),
            key: process.env[keyEnv] || process.env.REACT_APP_API_KEY || '',
        }
    }

    if (CENTRAL_ROUTER) {
        const safeCentralRouter = CENTRAL_ROUTER.endsWith('/') ? CENTRAL_ROUTER : `${CENTRAL_ROUTER}/`;

        return {
            address: `${safeCentralRouter}${serviceName}`,
            key: CENTRAL_ROUTER_API_KEY || '',
        }
    }

    console.warn(`⚠️ Environment variable ${apiEnv} and central router definition for service ${serviceName} are missing. Using default values for localhost.`);

    return {
        address: `${LOCAL_ADDRESS}/${serviceName}`,
        key: '',
    }
}

const appConfig = {
    appName: 'Backoffice',
    version: packageJson.version,
    env: process.env.REACT_APP_NODE_ENV || 'development',
    isProd: process.env.REACT_APP_NODE_ENV === 'prd',
    nodeEnv: process.env.NODE_ENV || 'development',
    awsAccountId: process.env.REACT_APP_AWS_ACCOUNT_ID || '',
    logLevel: process.env.REACT_APP_LOG_LEVEL || 'info',
    harvestReference: process.env.REACT_APP_HARVEST_REFERENCE || '',

    aws: {
        cognitoRegion: process.env.REACT_APP_AWS_COGNITO_REGION || '',
        userPoolsId: process.env.REACT_APP_AWS_USER_POOLS_ID || '',
        userPoolsWebClientId: process.env.REACT_APP_AWS_POOLS_WEB_CLIENT_ID || '',
    },

    apis: {
        backofficeApiUrl: process.env.REACT_APP_BACKOFFICE_URL || LOCAL_ADDRESS,
        backofficeApiKey: process.env.REACT_APP_API_KEY || '',
        geolocationApiEnv: getApiEnv('REACT_APP_GEOLOCATION_API_URL', 'REACT_APP_GEOLOCATION_API_KEY', 'geo-location'),
        personApiEnv: getApiEnv('REACT_APP_PERSON_API_URL', 'REACT_APP_PERSON_API_KEY', 'person'),
        communicationApiEnv: getApiEnv('REACT_APP_COMMUNICATION_API_URL', 'REACT_APP_COMMUNICATION_API_KEY', 'communication'),
        convertXmlApiEnv: getApiEnv('REACT_APP_CONVERT_XML_API_URL', 'REACT_APP_CONVERT_XML_API_KEY', 'convert-xml'),
        dataProviderApiEnv: getApiEnv('REACT_APP_DATA_PROVIDER_API_URL', 'REACT_APP_DATA_PROVIDER_API_KEY', 'data-provider'),
        contractsManagementApiEnv: getApiEnv('REACT_APP_CONTRACTS_MANAGEMENT_API_URL', 'REACT_APP_CONTRACTS_MANAGEMENT_API_KEY', 'contracts-management'),
        sicorApiEnv: getApiEnv('REACT_APP_SICOR_API_URL', 'REACT_APP_SICOR_API_KEY', 'sicor'),
        referralApiEnv: getApiEnv('REACT_APP_REFERRAL_API_URL', 'REACT_APP_REFERRAL_API_KEY', 'referral'),
        settlementApiEnv: getApiEnv('REACT_APP_SETTLEMENT_API_URL', 'REACT_APP_SETTLEMENT_API_KEY', 'settlement'),
        farmerAnalysisApiEnv: getApiEnv('REACT_APP_FARMER_ANALYSIS_API_URL', 'REACT_APP_FARMER_ANALYSIS_API_KEY', 'farmer-analysis'),
        billerApiEnv: getApiEnv('REACT_APP_BILLER_API_URL', 'REACT_APP_BILLER_API_KEY', 'biller'),
        settlementV2: getApiEnv('REACT_APP_SETTLEMENT_V2_API_URL', 'REACT_APP_SETTLEMENT_V2_API_KEY', 'settlement'),
        dimensaReaderApiEnv: getApiEnv('REACT_APP_DIMENSA_READER_API_URL', 'REACT_APP_DIMENSA_READER_API_KEY', 'dimensa-reader'),
        contractRegisterApiEnv: getApiEnv('REACT_APP_CONTRACT_REGISTER_API_URL', 'REACT_APP_CONTRACT_REGISTER_API_KEY', 'contract-register'),
        routerApiEnv: getApiEnv('REACT_APP_ROUTER_API_URL', 'REACT_APP_ROUTER_API_KEY', 'router'),
        recommendationEngineApiEnv: getApiEnv('REACT_APP_RECOMMENDATION_API_URL', 'REACT_APP_RECOMMENDATION_API_KEY', 'recommendation-engine'),
        legalApiEnv: getApiEnv('REACT_APP_LEGAL_API_URL', 'REACT_APP_LEGAL_API_KEY', 'legal'),
        collateralApiEnv: getApiEnv('REACT_APP_COLLATERAL_API_URL', 'REACT_APP_COLLATERAL_API_KEY', 'collateral'),
        signatureApiEnv: getApiEnv('REACT_APP_SIGNATURE_API_URL', 'REACT_APP_SIGNATURE_API_KEY', 'signature'),
        contractApiEnv: getApiEnv('REACT_APP_CONTRACT_API_URL', 'REACT_APP_CONTRACT_API_KEY', 'contract'),
        blocklistApiUrl: process.env.REACT_APP_API_GATEWAY_BLOCKLIST_URL || '',
        creditAnalysisApiEnv: getApiEnv('REACT_APP_CREDIT_ANALYSIS_API_URL', 'REACT_APP_CREDIT_ANALYSIS_API_KEY', 'cae'),
        cnpjSpotApiEnv: getApiEnv('REACT_APP_CNPJ_SPOT_API_URL', 'REACT_APP_CNPJ_SPOT_API_KEY', 'cnpj-spot'),
    },
};

export const apis = { ...appConfig.apis };

export default appConfig;